/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportGetConnectionByIdQueryResponse, SocialExportGetConnectionByIdPathParams, SocialExportGetConnectionById401, SocialExportGetConnectionById403, SocialExportGetConnectionById404 } from "../models/SocialExportGetConnectionById";

export function getSocialExportGetConnectionByIdUrl(id: SocialExportGetConnectionByIdPathParams["id"]) {
  const res = { method: 'GET', url: `/social-export/v1/connections/${id}` as const }
  return res
}

/**
 * @description Returns connection state, profile info, and linked station IDs for a single connection.
 * @summary Get a connection by id
 * {@link /social-export/v1/connections/:id}
 */
export async function socialExportGetConnectionById(id: SocialExportGetConnectionByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SocialExportGetConnectionByIdQueryResponse, ResponseErrorConfig<SocialExportGetConnectionById401 | SocialExportGetConnectionById403 | SocialExportGetConnectionById404>, unknown>({ method : "GET", url : getSocialExportGetConnectionByIdUrl(id).url.toString(), ... requestConfig })
  return res.data
}